var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWarning = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11049_211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.084 11.2462L7.87531 2.25021C7.58931 1.75621 7.44198 1.50488 7.25998 1.41821C7.09531 1.34888 6.91331 1.34888 6.74865 1.41821C6.55798 1.50488 6.41931 1.74754 6.13331 2.25021L0.91598 11.2462C0.621313 11.7489 0.482646 12.0002 0.49998 12.1995C0.517313 12.3815 0.612646 12.5375 0.75998 12.6502C0.924646 12.7715 1.21065 12.7715 1.79131 12.7715H12.2086C12.7893 12.7715 13.0753 12.7715 13.24 12.6502C13.3873 12.5462 13.4826 12.3815 13.5 12.1995C13.5173 11.9915 13.3786 11.7489 13.084 11.2462ZM6.18531 10.3709C6.18531 9.28754 7.80598 9.28754 7.80598 10.3709C7.80598 11.4542 6.18531 11.4542 6.18531 10.3709ZM7.80598 7.51954C7.80598 7.73621 7.72798 7.94421 7.57198 8.10021C7.41598 8.24754 7.21665 8.33421 6.99998 8.33421C6.78331 8.33421 6.57531 8.24754 6.41931 8.10021C6.27198 7.94421 6.18531 7.73621 6.18531 7.51954V5.49154C6.18531 5.27488 6.27198 5.06688 6.41931 4.91954C6.57531 4.76354 6.78331 4.67688 6.99998 4.67688C7.21665 4.67688 7.41598 4.76354 7.57198 4.91954C7.72798 5.06688 7.80598 5.27488 7.80598 5.49154V7.51954Z",
    fill: "#5849A6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11049_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/warning.8f8e3399.svg";
export { ForwardRef as ReactComponent };